const WAY_UP_DEF_IMG = '/static-backend/images/defualt_img.jpg'

export{
    WAY_UP_DEF_IMG
}